<div class="d-flex flex-column">
  <textarea [value]="serial" style="height: 26rem;"></textarea>
  <sb-button classes="btn-primary mt-2"
             (click)="copyToClipboard()">{{'lang.globals.copy' | translate}}</sb-button>
</div>
